import { render } from "./ItemView.vue?vue&type=template&id=1ae5bfc2"
import script from "./ItemView.vue?vue&type=script&lang=js"
export * from "./ItemView.vue?vue&type=script&lang=js"

import "./ItemView.vue?vue&type=style&index=0&id=1ae5bfc2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/ItemView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ae5bfc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ae5bfc2', __exports__)) {
    api.reload('1ae5bfc2', __exports__)
  }
  
  module.hot.accept("./ItemView.vue?vue&type=template&id=1ae5bfc2", () => {
    api.rerender('1ae5bfc2', render)
  })

}


export default __exports__